"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_arrow_incoming_style_1 = __importDefault(require("./uicon.arrow.incoming.style"));
class UiconArrowIncoming extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: [jsx_runtime_1.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.42869 3.05288C4.68819 2.94539 4.98688 3.00481 5.18549 3.20342L10.5376 8.55558H28.3056V9.94446H10.5376L5.18549 15.2966C4.98688 15.4952 4.68819 15.5546 4.42869 15.4472C4.1692 15.3397 4 15.0865 4 14.8056V3.69446C4 3.41359 4.1692 3.16037 4.42869 3.05288ZM9.26791 9.25002L5.38889 5.371V13.129L9.26791 9.25002Z", className: classes.fill }, void 0),
                    jsx_runtime_1.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.0603 15.5685C21.3009 15.4529 21.5865 15.4854 21.7949 15.6522L28.7394 21.2077C28.9041 21.3395 29 21.539 29 21.75C29 21.961 28.9041 22.1605 28.7394 22.2923L21.7949 27.8478C21.5865 28.0146 21.3009 28.0471 21.0603 27.9315C20.8197 27.8158 20.6667 27.5725 20.6667 27.3056V22.4445H4.69446V21.0556H20.6667V16.1945C20.6667 15.9275 20.8197 15.6842 21.0603 15.5685ZM22.0556 17.6393V25.8607L27.1939 21.75L22.0556 17.6393Z", className: classes.fill }, void 0)] }), void 0));
        };
    }
}
UiconArrowIncoming.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconArrowIncoming.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_arrow_incoming_style_1.default)(UiconArrowIncoming);
//# sourceMappingURL=uicon.arrow.incoming.js.map